import { render, staticRenderFns } from "./VehiclePieChart.vue?vue&type=template&id=f4ee7b0a&"
import script from "./VehiclePieChart.vue?vue&type=script&lang=js&"
export * from "./VehiclePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports